import { render } from "./TermsConditions.vue?vue&type=template&id=3e78e354"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./TermsConditions.vue?vue&type=style&index=0&id=3e78e354&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__